/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '@app/settings/companies/company.model';
import { CompaniesFormComponent } from '@app/settings/companies/companies-form/companies-form.component';

@Injectable({
  providedIn: 'root',
})
export class CompaniesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open company form
   * @param company Dialog data
   */
  public open(company: null | Company = null): Promise<any> {
    const modal = this.modalService.open(CompaniesFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.company = company;
    return modal.result;
  }
}
